import React from "react";

const IconRolePress = ({ ...rest }) => {
  return (
    <svg viewBox="0 0 48 48" fill="currentColor" {...rest}>
      <path d="M37,13.9H12c-0.6,0-1,0.4-1,1v27c0,0.6,0.4,1,1,1h25c0.6,0,1-0.4,1-1v-27C38,14.3,37.6,13.9,37,13.9 z M16.2,18.7h6.2c0.7,0,1.2,0.6,1.2,1.2c0,0.6-0.6,1.2-1.2,1.2h-6.2c-0.7,0-1.2-0.6-1.2-1.2C15,19.3,15.6,18.7,16.2,18.7z M16.2,24.6h6.2c0.7,0,1.2,0.6,1.2,1.2c0,0.7-0.6,1.2-1.2,1.2h-6.2c-0.7,0-1.2-0.6-1.2-1.2S15.6,24.6,16.2,24.6z M31.5,39.1H16.3 c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2h15.2c0.7,0,1.2,0.6,1.2,1.2C32.8,38.6,32.2,39.1,31.5,39.1z M31.5,33.1H16.3 c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2h15.2c0.7,0,1.2,0.6,1.2,1.2C32.8,32.6,32.2,33.1,31.5,33.1z M33,25.5 c0,0.6-0.4,1-1,1h-4c-0.6,0-1-0.4-1-1V20c0-0.6,0.4-1,1-1h4c0.6,0,1,0.4,1,1V25.5z" />
      <path d="M33.8,5.1L11.6,9.7c-0.4,0.1-0.6,0.4-0.6,0.8c0,0.5,0.4,0.8,0.8,0.8H34c0.6,0,1-0.4,1-1V6.1 C35,5.5,34.4,5,33.8,5.1L33.8,5.1z" />
    </svg>
  );
};

export default IconRolePress;
